(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["epp-cart-sync"] && !Shopify.designMode) return;
  try {
    class EppCartSync extends HTMLElement {
    static settled = new Set(['guest', 'eligible', 'not-eligible']);

    connectedCallback() {
      this.onState = (event) => this.sync(event.detail.state);
      document.addEventListener('epp:eligibility', this.onState);
      this.sync(document.documentElement.dataset.eppState);
    }

    disconnectedCallback() {
      document.removeEventListener('epp:eligibility', this.onState);
    }

    async sync(state) {
      if (!EppCartSync.settled.has(state)) return;
      if (Number(this.dataset.cartCount) === 0) return;
      if (this.dataset.cartState === state || this.pending) return;
      this.pending = true;
      try {
        const response = await fetch(this.dataset.updateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: { epp_state: state } }),
        });
        if (!response.ok) return;
        this.dataset.cartState = state;
        await this.rerender();
      } catch {
        // the next load or state change tries again
      } finally {
        this.pending = false;
      }
    }

    // Ask every cart section on the page to fetch itself again, the same way
    // Horizon's cart component does after an external update.
    async rerender() {
      const components = document.querySelectorAll('cart-items-component');
      if (components.length === 0) return;
      const { sectionRenderer } = await import('@theme/section-renderer');
      for (const component of components) {
        sectionRenderer.renderSection(component.sectionId, {
          cache: false,
          mode: component.isDrawer ? 'hydration' : 'full',
        });
      }
    }
  }

  if (!customElements.get('epp-cart-sync')) {
    customElements.define('epp-cart-sync', EppCartSync);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["epp-eligibility"] && !Shopify.designMode) return;
  try {
    class EppEligibility extends HTMLElement {
    static polling = null;

    connectedCallback() {
      this.addEventListener('click', this.#onClick);
      this.addEventListener('keydown', this.#onKeydown);
      document.addEventListener('click', this.#onDocumentClick);
      if (this.dataset.state === 'checking') EppEligibility.poll(this);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.#onDocumentClick);
    }

    // Listeners sit on the element, not the pill, so they survive the swap.
    #onClick = (event) => {
      const pill = event.target.closest('button.epp-eligibility__pill');
      if (!pill) return;
      const open = pill.getAttribute('aria-expanded') !== 'true';
      this.close();
      pill.setAttribute('aria-expanded', String(open));
    };

    #onKeydown = (event) => {
      if (event.key !== 'Escape') return;
      const pill = this.querySelector('button.epp-eligibility__pill[aria-expanded="true"]');
      if (!pill) return;
      this.close();
      pill.focus();
    };

    #onDocumentClick = (event) => {
      if (!this.contains(event.target)) this.close();
    };

    close() {
      this.querySelectorAll('button.epp-eligibility__pill').forEach((pill) => {
        pill.setAttribute('aria-expanded', 'false');
      });
    }

    static poll(element) {
      if (EppEligibility.polling) return;
      const interval = Number(element.dataset.interval);
      const deadline = Date.now() + Number(element.dataset.timeout);
      const section = element.dataset.section;

      EppEligibility.polling = setInterval(async () => {
        const fetched = await EppEligibility.fetchState(section);
        const state = fetched?.querySelector('epp-eligibility')?.dataset.state;
        if (state && state !== 'checking') {
          EppEligibility.settle(state, fetched);
        } else if (Date.now() > deadline) {
          EppEligibility.settle('timed-out');
        }
      }, interval);
    }

    static async fetchState(section) {
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('sections', section);
        const response = await fetch(url, { credentials: 'same-origin' });
        if (!response.ok) return null;
        const html = (await response.json())[section];
        return new DOMParser().parseFromString(html, 'text/html');
      } catch {
        return null;
      }
    }

    // The fetched markup of the same form replaces the page's, so content
    // rendered from the customer's tags and organisation, such as the logo,
    // arrives with the state.
    static settle(state, fetched) {
      clearInterval(EppEligibility.polling);
      // The Corporate+ price is rendered for eligible customers only, so a page
      // that showed prices while the check ran reloads once to receive them.
      if (state === 'eligible' && document.querySelector('.epp-price')) {
        window.location.reload();
        return;
      }
      document.querySelectorAll('epp-eligibility').forEach((element) => {
        const match = fetched?.querySelector(`epp-eligibility[data-form="${element.dataset.form}"]`);
        if (match) element.innerHTML = match.innerHTML;
        element.dataset.state = state;
      });
      document.documentElement.dataset.eppState = state;
      document.dispatchEvent(new CustomEvent('epp:eligibility', { detail: { state } }));
    }
  }

  if (!customElements.get('epp-eligibility')) {
    customElements.define('epp-eligibility', EppEligibility);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["epp-limit"] && !Shopify.designMode) return;
  try {
    class EppLimit extends HTMLElement {
    connectedCallback() {
      this.input = this.closest('.quantity-selector-wrapper')?.querySelector('input[type="number"]');
      if (!this.input) return;
      this.apply(document.documentElement.dataset.eppState);
      this.onState = (event) => this.apply(event.detail.state);
      document.addEventListener('epp:eligibility', this.onState);
      // On a variant change Horizon copies the new min, max and step onto the
      // selector but not the new variant's cart count, so the limit would keep
      // subtracting the previous variant's. Take it from the fetched markup.
      this.section = this.closest('.shopify-section, dialog');
      this.onSelect = (event) => this.onVariantChange(event);
      this.section?.addEventListener('shopify:product:select', this.onSelect);
    }

    disconnectedCallback() {
      this.section?.removeEventListener('shopify:product:select', this.onSelect);
      document.removeEventListener('epp:eligibility', this.onState);
    }

    // The limit follows the state; the selector's max is the limit unless a
    // Shopify quantity rule is stricter.
    apply(state) {
      const limit = Number(state === 'eligible' ? this.dataset.limitEligible : this.dataset.limitOther);
      this.dataset.limit = String(limit);
      const rule = Number(this.input.dataset.ruleMax) || Infinity;
      const selector = this.input.closest('quantity-selector-component, cart-quantity-selector-component');
      const max = Math.min(limit, rule);
      if (selector?.updateConstraints) {
        selector.updateConstraints(this.input.min, String(max), this.input.step);
      } else {
        this.input.max = String(max);
      }
      this.refresh();
    }

    async onVariantChange(event) {
      if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
      try {
        const { detail } = await event.promise;
        const fetched = detail?.html?.querySelector('quantity-selector-component input[ref="quantityInput"]');
        if (!fetched) return;
        const selector = this.input.closest('quantity-selector-component');
        const cartQuantity = Number(fetched.dataset.cartQuantity) || 0;
        if (selector?.setCartQuantity) selector.setCartQuantity(cartQuantity);
        else this.input.dataset.cartQuantity = String(cartQuantity);
        this.apply(document.documentElement.dataset.eppState);
      } catch {
        // an aborted fetch; the next selection will update
      }
    }

    // The note always shows; only its count follows the state.
    refresh() {
      const count = this.querySelector('.epp-limit__note [data-limit-count]');
      if (count) count.textContent = this.dataset.limit;
    }
  }

  if (!customElements.get('epp-limit')) {
    customElements.define('epp-limit', EppLimit);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["epp-sign-in"] && !Shopify.designMode) return;
  try {
    class EppSignIn extends HTMLElement {
    static links = 'a[href^="/account/login"], a[href*="/customer_authentication/"]';
    static attempts = 10;
    static interval = 300;

    connectedCallback() {
      this.onClick = (event) => this.signIn(event);
      document.addEventListener('click', this.onClick);
      this.hideMenu(EppSignIn.attempts);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onClick);
    }

    signIn(event) {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target instanceof Element ? event.target.closest(EppSignIn.links) : null;
      if (!link) return;

      const button = this.sheetButton();
      if (button) {
        event.preventDefault();
        // after this click has finished, or the sheet reads it as a click outside
        setTimeout(() => this.openSheet(button, EppSignIn.attempts), 0);
        return;
      }
      if (this.dataset.loginUrl) {
        event.preventDefault();
        window.location.assign(this.dataset.loginUrl);
      }
    }

    // The component ignores clicks until it is ready, shortly after the page
    // loads. Try again until the sheet is open, then give up and use the page.
    openSheet(button, attempts) {
      if (this.sheetIsOpen()) return;
      if (attempts === 0) {
        if (this.dataset.loginUrl) window.location.assign(this.dataset.loginUrl);
        return;
      }
      button.click();
      setTimeout(() => this.openSheet(button, attempts - 1), EppSignIn.interval);
    }

    sheetIsOpen() {
      const root = document.querySelector('shopify-account')?.shadowRoot;
      return root?.querySelector('dialog[open], [popover]:popover-open') != null;
    }

    // The component builds its sheet a moment after the page loads.
    async hideMenu(attempts) {
      await customElements.whenDefined('shopify-account');
      const root = document.querySelector('shopify-account')?.shadowRoot;
      if (!root) {
        if (attempts > 0) setTimeout(() => this.hideMenu(attempts - 1), EppSignIn.interval);
        return;
      }
      if (!('adoptedStyleSheets' in root)) return;
      const sheet = new CSSStyleSheet();
      sheet.replaceSync('.account__menu-region { display: none; }');
      root.adoptedStyleSheets = [...root.adoptedStyleSheets, sheet];
    }

    sheetButton() {
      const account = document.querySelector('shopify-account');
      const root = account?.shadowRoot;
      if (!root || account.getClientRects().length === 0) return null;
      const button =
        root.querySelector('button[popovertarget], button[aria-haspopup]') ?? root.querySelector('button');
      return button instanceof HTMLElement ? button : null;
    }
  }

  if (!customElements.get('epp-sign-in')) {
    customElements.define('epp-sign-in', EppSignIn);
  }
  } catch(e) { console.error(e); }
})();

})();
